import React, { useReducer } from 'react';

interface Props {
  children: React.ReactNode;
}

// Just an example, none of below props currently used
interface AppState {
  isLoggedIn: boolean,  
  accessToken: string | undefined,
  errors: []
}

interface AppStateValues {
  state: AppState,
  dispatch: React.Dispatch<Action>
}

type AuthenticateUser = { type: 'AUTHENTICATE_USER', payload: { 'isLoggedIn': boolean, 'accessToken': string } };
type Action = AuthenticateUser ;

// Examples
// type GoToDefaultView = { type: 'GOTO_DEFAULT_VIEW', payload: { 'currentOperation': string } };
// type GoToErrorView = { type: 'GOTO_ERROR_VIEW', payload: { 'message': string } };
// type Action = GoToDefaultView | GoToErrorView | AuthenticateUser ;

const AppStateContext = React.createContext<undefined | AppStateValues>(undefined);
const Provider = AppStateContext.Provider;

const initialState: AppState = {
  isLoggedIn: false,  
  accessToken: undefined,
  errors: []
};

const reducer = (state: AppState, action: Action): AppState => {
  
  console.log('AppStateProvider.reducer');
  
  switch (action.type) {
    // case 'GOTO_DEFAULT_VIEW': {
    //   return {        
    //     ...state,
    //     currentOperation: action.payload.currentOperation,
    //     errorCount: 0,
    //     errors: []
    //   };
    // }

    // case 'GOTO_ERROR_VIEW': {
    //   return {
    //     ...state,
    //     currentError: action.payload.message
    //   };
    // }

    case 'AUTHENTICATE_USER': {
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn, 
        accessToken: action.payload.accessToken
      };
    }

    default:
      throw new Error('Unexpected action type in reducer');
  }
};

function AppStateProvider({ children }: Props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  // useEffect(() => { console.log(`AppStateProvider.useEffect [] - display name: ${state.displayName}`); }, []);
  return (
    <Provider value={{ state, dispatch }}>
      {children}
    </Provider>
  );
}

function useAppStateContext() {
  const context = React.useContext(AppStateContext);
  if (context === undefined) throw new Error('useAppStateContext must be used within an AppStateProvider!');
  return context;
}

export {
  AppStateProvider,
  useAppStateContext
};
  
export type { Action };

